import styled from 'styled-components'
import Lottie from 'lottie-react'
import loadingLottie from 'src/assets/imgs/lottie/mfinder-global-loading-animation.json'
import { useAppSelector } from 'src/hooks/redux/useAppSelector'
import { RootState } from 'src/store/store'
import { useEffect, useRef } from 'react'
import { setLoadingStatus } from 'src/store/Reducer/common/commonSlice'
import { useAppDispatch } from 'src/hooks/redux/useAppDispatch'
import { COLOR } from 'src/constants/colors'
import { useLockBodyScrollHook } from 'src/hooks/useLockBodyScroll.hook'

const Loading = () => {
  const { RecaptchaTokenUpdateFlag, loadingStatus } = useAppSelector(
    (state: RootState) => state.common,
  )
  const dispatch = useAppDispatch()
  const loadingRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    setTimeout(() => {
      loadingStatus && dispatch(setLoadingStatus(false))
    }, 1500)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingStatus])

  // 버튼을 클릭해서 로딩화면이 노출 되는 경우 이전 버튼에서의 포커스가 풀리지 않아
  // 스페이스바, 엔터 등으로 버튼 submit이 계속일어나는 이슈를 해야하기 위한 곳
  useEffect(() => {
    loadingStatus && loadingRef.current !== null && loadingRef.current.focus()
  }, [loadingStatus])

  useLockBodyScrollHook(loadingStatus)

  return (
    <>
      {(!RecaptchaTokenUpdateFlag || loadingStatus) && (
        <LoadingWrap ref={loadingRef}>
          <Lottie animationData={loadingLottie} />
        </LoadingWrap>
      )}
    </>
  )
}
export default Loading

const LoadingWrap = styled.div`
  display: block;
  z-index: 9998;
  width: 100%;
  overflow: hidden;
  min-height: calc(var(--vh, 1vh) * 100);
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: ${COLOR.blackOpacity07};
  justify-content: center;
  align-items: center;
  > div {
    width: 140px;
    height: 140px;
    margin: 0 auto;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`
